import React from 'react';
import { useSnackbarContext } from 'Context/SnackbarContext';
import SnackbarItem from './SnackbarItem';

const SnackbarContent = () => {
  const { items } = useSnackbarContext();

  return (
    <React.Fragment>
      {items.map((item) => {
        return (
          <SnackbarItem
            key={item.id}
            item={item}
          />
        );
      })}
    </React.Fragment>
  );
};


export default SnackbarContent;
